module.exports = __webpack_public_path__ + "media/images/landing/people-retina-mobile-7e55b63d6921095f92ec689a3c963d06.png";